import React, { useEffect, useState } from 'react';
import {  ListMasterData } from '../../functionsMaster';
import PropTypes from 'prop-types';

const PickLocationSelect = ({
  changeFunction = () => { console.error("No Change Function in PickLocationSelect "); }, 
  requiredValue = false, 
}) => {
    const [pickUpLoc, setPickUpLoc] = useState(localStorage.getItem('pickUpLoc'));
    const [branchLocation, setBranchLocation] = useState([]);

  useEffect(() => {
    const CACHE_DURATION = 60 * 60 * 1000;
    const fetchData = async () => {
      const config = [{ key: 'branchLocation', setter: setBranchLocation }];
      await Promise.all(
        config.map(async ({ key, setter }) => {
          const cacheKey = `liveData${key}`;
          const cacheRaw = localStorage.getItem(cacheKey);
          if (cacheRaw) {
            const { timestamp, data } = JSON.parse(cacheRaw);
            if (Date.now() - timestamp < CACHE_DURATION && Array.isArray(data)) {
              if (data && data.length > 0) {
                setter(data);
              }
              return;
            }
          }
          try {
            const res = await ListMasterData(key, { status: 1, limitedData: 'No' });
            const data = Array.isArray(res.data) ? res.data : [];
            setter(data);
            localStorage.setItem(cacheKey, JSON.stringify({ timestamp: Date.now(), data }));
          } catch (err) {
            console.error(`Failed to fetch ${key}`, err);
            setter([]);
          }
        })
      );
    };
    fetchData();
  }, []);

  return (
            <select
                className="form-control"
                required={requiredValue}
                value={pickUpLoc ? pickUpLoc : ''}
                onChange={(e) => {
                  localStorage.setItem('pickUpLoc', e.target.value);
                  setPickUpLoc(e.target.value);
                  const value = e.target.value; // e.g., "123:123:0"
                  const [id, pickIndex, pickCharge] = value.split(":");
                  const result = branchLocation.find((item) => item._id === id);
                  if (id === pickIndex && result) {
                      // on office
                      localStorage.removeItem('pickCharge');
                      localStorage.removeItem('pickIndex');
                      localStorage.setItem('pickTitle', result.title);
                      localStorage.setItem('pickAddress', result.location);
                  } else if (result) {
                      // on pickup location
                      localStorage.setItem('pickCharge', pickCharge);
                      localStorage.setItem('pickIndex', pickIndex);
                      try {
                          const temp = result.pickDropCharges[pickIndex];
                          localStorage.setItem('pickTitle', temp.name);
                          localStorage.setItem('pickAddress', temp.address); 
                      } catch(e) {
                          console.error(e);
                      }
                      
                  }
                  try {
                      changeFunction();
                  } catch(e) {
                      console.error(e, id);
                  }
                }}
            >
                <option value="">Select Location</option>
                {branchLocation.map((s = { title: '', location: '', _id: '' }) => (
                <option key={s._id} value={`${s._id}:${s._id}:0`}>
                    {s.title}
                    {/* ({s.location}) */}
                </option>
                ))}
                {branchLocation.flatMap((s = { name: '', address: '', _id: '', pickDropCharges: [] }) =>
                s.pickDropCharges?.map((s1 = { name: '', pkgID: '', address: '', cost: '' }, i1) => (
                    <option key={i1} value={`${s._id}:${i1}:${s1.cost}`}>
                      {s1.name} 
                      {/* ({s1.address}) */}
                    </option>
                )) || []
                )}
            </select>
  );
};

PickLocationSelect.propTypes = {
  changeFunction: PropTypes.func.isRequired,
  requiredValue: PropTypes.any.isRequired,
};

export default PickLocationSelect;
